import RefinementError, { type RefinementError as RefinementErrorCode } from '$/_const/trip/RefinementError.ts';

const SPEND_CAP_STATUS = 503;

const refineDayErrorKey = (code?: RefinementErrorCode, status?: number): string => {
  if (code === RefinementError.NO_MATERIAL_CHANGE) return 'tripPage.error_refine_day_no_change';
  if (code === RefinementError.REQUEST_TIMEOUT) return 'tripPage.error_refine_day_timeout';
  if (status === SPEND_CAP_STATUS) return 'tripPage.error_refine_day_busy';
  return 'tripPage.error_refine_day';
};

export default refineDayErrorKey;
